import { render, staticRenderFns } from "./AirticketyudingRight.vue?vue&type=template&id=f41459de&scoped=true"
import script from "./AirticketyudingRight.vue?vue&type=script&lang=js"
export * from "./AirticketyudingRight.vue?vue&type=script&lang=js"
import style0 from "./AirticketyudingRight.vue?vue&type=style&index=0&id=f41459de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f41459de",
  null
  
)

export default component.exports